<div class="move-how-type-items" [ngClass]="className">
  @for (item of items; track item) {
    <div
      [class]="'type-item type-item--' + item.type"
      [class.disabled-type]="isDisabledType(item.type)"
      [class.active]="selectedItem === item.type"
      (click)="onItemClick(item.type)"
    >
      <div class="type-icon" [ngClass]="'type-icon-' + item.type">
        @if (item.iconName) {
          <rkt-icon [name]="item.iconName"></rkt-icon>
        }
      </div>
      <div class="type-label">{{ item.label }}</div>
    </div>
  }
</div>
